module.exports = __webpack_public_path__ + "img/dollar-icon.2bf56d20.svg";